/* eslint-disable no-useless-escape */
export default {
  regex: {
    time: /^(([0-1]?[0-9])|(2[0-4])):[0-6]?[0-9]$/,
    date: /^(1399|14[0-4][0-9])\/(0?[1-9]|1[0-2])\/(0?[1-9]|1[0-9]|2[0-9]|30|31)$/,
    dateTime: /^\d{4}[\/](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])[ ]((([0-1]?[0-9]|2[0-3]):[0-5][0-9])|24:00)$/
  },

  moment: {
    year: 'YYYY',
    month: 'MM',
    fullMonth: 'jMMMM',
    day: 'jDD',
    weekDayIndex: 'e',
    yearMonth: 'jYY/jMM',
    fullYearMonth: 'jYYYY/jMM',
    time: 'HH:mm',
    date: 'jYYYY/jMM/jDD',
    dateTime: 'jYYYY/jMM/jDD HH:mm',
    dateWithWeek: 'dddd jD jMMMM jYYYY',
    fullDateTime: 'YYYY-M-D HH:mm:ss'
  }
}
